// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pincurchin: PokeData = {
  "id": 871,
  "name": "pincurchin",
  "height": 3,
  "weight": 10,
  "base_experience": 152,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "fury-attack",
    "water-gun",
    "bubble-beam",
    "peck",
    "thunder-shock",
    "recover",
    "curse",
    "spark",
    "charge",
    "acupressure",
    "poison-jab",
    "discharge",
    "electric-terrain",
    "zing-zap"
  ],
  "moves": [
    "bubble-beam",
    "peck",
    "thunder-shock",
    "curse",
    "poison-jab",
    "electric-terrain",
    "thunder-punch",
    "thunderbolt",
    "volt-crash",
    "quick-tempo",
    "electric-wrath",
    "zap-cannon",
    "wild-charge"
  ],
  "evolution_chain": {
    "id": 454,
    "item": null,
    "species": [
      {
        "name": "pincurchin",
        "order": 871,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 138,
    "speed": 30,
    "ability_power": 202
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
